<template>
	<div class="formulate-v-calendar">
		<v-date-picker
			:id="context.id"
			v-model="vcalendar"
			:value="vcalendar"
			:min-date="minDate"
			:max-date="maxDate"
			:popover="{ visibility: 'click' }"
			:name="context.name"
			is-dark>
			<template #default="{ inputValue, inputEvents }">
				<b-input-group>
					<template #prepend>
						<b-input-group-text>
							<font-awesome-icon :icon="['fas', 'calendar']" />
						</b-input-group-text>
					</template>
					<b-form-input
						:ref="`date_` + context.name"
						onkeydown="return false"
						placeholder="MM / DD / YYYY"
						:value="renderDate(inputValue, $parent.$data.proxy)"
						:state="vcalendar && length(context.validationErrors) === 0"
						autocomplete="off"
						v-on="inputEvents"></b-form-input>

					<template v-if="(vcalendar || $parent.$data.proxy)" #append>
						<b-input-group-text class="cursor-pointer" @click="vcalendar = null; $parent.$data.proxy = null">
							<font-awesome-icon title="Clear Selected Date" :icon="['fas', 'times']" />
						</b-input-group-text>
					</template>
				</b-input-group>
			</template>
		</v-date-picker>

		<small v-if="isStaff && context.attributes.min" class="text-roboto-mono text-warning m-1 d-block">
			Admin Alert: Minimum selectable date is: {{ context.attributes.min | humanDate }}
		</small>
	</div>
</template>
<script>
import auth from '@/Mixin/auth'

export default {
	mixins: [auth],
	props: {
		context: {
			type: Object,
			required: true
		}
	},
	data () {
		return  {
			vcalendar: null
		}
	},
	computed: {
		minDate () {
			if (this.isStaff) {
				return null
			}

			if (this.context.attributes.min) {
				return this.parseDate(this.context.attributes.min)
			}

			return new Date()
		},
		maxDate () {
			if (this.isStaff) {
				return null
			}

			if (this.context.attributes.max) {
				this.$nextTick(() => {
					return this.parseDate(this.context.attributes.max)
				})
			}

			let maxDate = new Date()
			maxDate.setFullYear(maxDate.getFullYear() + 2)
			maxDate.setDate(maxDate.getDate() + 1)
			maxDate = this.parseDate(maxDate)

			return maxDate
		}
	},
	watch: {
		vcalendar (date) {
			if (! date instanceof Date || isNaN(date)) {
				return
			}

			if (! date) {
				// eslint-disable-next-line vue/no-mutating-props
				this.context.model = null
				return
			}

			// eslint-disable-next-line vue/no-mutating-props
			this.context.model = this.formatDate(date)
		}
	},
	mounted () {
		this.$nextTick(() => {
			this.vcalendar = this.parseDate(this.context.model)
		})
	},
	methods: {
		formatDate (date) {
			if (! date) {
				return
			}

			let d = new Date(date),
				month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear()

			if (month.length < 2) {
				month = '0' + month
			}

			if (day.length < 2) {
				day = '0' + day
			}

			return [year, month, day].join('-')
		},
		parseDate (dateString) {
			if (typeof dateString !== 'string') {
				return dateString
			}

			// If we pass in the date with dashes here then the timezone takes over
			// we're just replacing the dashes so date sees it as UTC since we don't care about time

			dateString = dateString.split('-')

			let newDate = new Date()
			newDate.setFullYear(parseInt(dateString[0]))
			newDate.setMonth(parseInt(dateString[1]) - 1)
			newDate.setDate(parseInt(dateString[2]))

			return newDate
		},
		renderDate (input, parentProxy) {
			if (input) return input

			if (parentProxy) {
				const proxyDate = parentProxy.split('-')
				return proxyDate[1] + '/' +
					proxyDate[2] + '/' +
					proxyDate[0]
			}
		}
	}
}
</script>
